import React, { memo } from "react";
import { Typography as AntTypography } from "antd";
import type { TitleProps } from "antd/es/typography/Title";
import type { ParagraphProps } from "antd/es/typography/Paragraph";
import type { TextProps } from "antd/es/typography/Text";
import { cn } from "src/util/cn";

const baseTextClass = "!text-[var(--color-black)]";

const CustomTypographyWrap: React.FC<{ children?: React.ReactNode; className?: string }> = ({
  className,
  children,
}) => <div className={cn(baseTextClass, className)}>{children}</div>;

const CustomTitle: React.FC<TitleProps> = ({ className, ...props }) => (
  <AntTypography.Title className={cn(baseTextClass, className)} {...props} />
);

const CustomParagraph: React.FC<ParagraphProps> = ({ className, ...props }) => (
  <AntTypography.Paragraph className={cn(baseTextClass, className)} {...props} />
);

const CustomText: React.FC<TextProps> = ({ className, ...props }) => (
  <AntTypography.Text className={cn(baseTextClass, className)} {...props} />
);

export const CustomTypography = {
  CustomTypographyWrap: memo(CustomTypographyWrap),
  CustomTitle: memo(CustomTitle),
  CustomParagraph: memo(CustomParagraph),
  CustomText: memo(CustomText),
};

export default CustomTypography;
